import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { getToken } from '../../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ServiciosAdmin = () => {
  const [servicios, setServicios] = useState([]);
  const [nuevoServicio, setNuevoServicio] = useState({ nombre: '', duracion: '', precio: '' });

  const cargarServicios = async () => {
    const token = getToken();
    try {
      const res = await api.get('/servicios', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServicios(res.data.servicios || []);
    } catch (err) {
      console.error('❌ Error al cargar servicios:', err);
      toast.error('Error al cargar los servicios');
    }
  };
  

  useEffect(() => {
    cargarServicios();
  }, []);

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    setServicios(prev =>
      prev.map(serv => (serv.id === id ? { ...serv, [name]: value } : serv))
    );
  };

  const guardarCambios = async (id, nombre, duracion, precio) => {
    const token = getToken();
    try {
      await api.put(
        `/servicios/${id}`,
        { nombre, duracion, precio },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Servicio actualizado correctamente');
      cargarServicios();
    } catch (err) {
      console.error('❌ Error al actualizar servicio:', err);
      toast.error('Error al actualizar servicio');
    }
  };

  const crearServicio = async () => {
    const { nombre, duracion, precio } = nuevoServicio;

    if (!nombre || !duracion || !precio) {
      toast.warning('Completa todos los campos');
      return;
    }

    const token = getToken();
    try {
      await api.post(
        '/servicios',
        { nombre, duracion, precio },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Servicio creado correctamente');
      setNuevoServicio({ nombre: '', duracion: '', precio: '' });
      cargarServicios();
    } catch (err) {
      console.error('❌ Error al crear servicio:', err);
      toast.error('Error al crear el servicio');
    }
  };

  const eliminarServicio = async (id) => {
    const confirmar = window.confirm('¿Seguro que deseas eliminar este servicio?');
    if (!confirmar) return;

    const token = getToken();
    try {
      await api.delete(`/servicios/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Servicio eliminado');
      cargarServicios();
    } catch (err) {
      console.error('❌ Error al eliminar servicio:', err);
      toast.error('No se pudo eliminar el servicio');
    }
  };

  return (
    <main className="site-width">

      <div className="texto-dashboard">
        <h1>Gestión de servicios</h1>
        <p>Añade, modifica y elimina servicios para tus clientes.</p>
      </div>

      <div className="grid-servicios-admin">
        <div className="tabla-servicios">
          <h2>Servicios activos</h2>
          {servicios.map(serv => (
            <div key={serv.id} className="fila-servicio">
              <div className="label-form">
                <label htmlFor={`nombre-${serv.id}`}>Nombre</label>
                <input
                  id={`nombre-${serv.id}`}
                  type="text"
                  name="nombre"
                  value={serv.nombre}
                  onChange={(e) => handleChange(e, serv.id)}
                  placeholder="Nombre"
                />
              </div>

              <div className="label-form">
                <label htmlFor={`duracion-${serv.id}`}>Duración <span>(min)</span></label>
                <input
                  id={`duracion-${serv.id}`}
                  type="number"
                  name="duracion"
                  value={serv.duracion}
                  onChange={(e) => handleChange(e, serv.id)}
                  placeholder="Duración"
                />
              </div>

              <div className="label-form">
                <label htmlFor={`precio-${serv.id}`}>Precio <span>(€)</span></label>
                <input
                  id={`precio-${serv.id}`}
                  type="number"
                  name="precio"
                  value={serv.precio}
                  onChange={(e) => handleChange(e, serv.id)}
                  placeholder="Precio"
                />
              </div>

              <div className="botones-servicios-admin">
                <button
                    className="boton-guardar-servicio"
                    onClick={() =>
                    guardarCambios(serv.id, serv.nombre, serv.duracion, serv.precio)
                    }
                >
                    Guardar
                </button>
                <button
                    className="boton-eliminar-servicio"
                    onClick={() => eliminarServicio(serv.id)}
                >
                    Eliminar
                </button>
              </div>
            
            </div>
          ))}
        </div>

        <div className="nuevo-servicio">
          <h2>Crear nuevo servicio</h2>

          <div className="label-form">
            <label htmlFor="nuevo-nombre">Nombre del servicio</label>
            <input
              id="nuevo-nombre"
              type="text"
              placeholder="Nombre"
              value={nuevoServicio.nombre}
              onChange={(e) =>
                setNuevoServicio({ ...nuevoServicio, nombre: e.target.value })
              }
            />
          </div>

          <div className="label-form">
            <label htmlFor="nuevo-duracion">Duración <span>(min)</span></label>
            <input
              id="nuevo-duracion"
              type="number"
              placeholder="Duración"
              value={nuevoServicio.duracion}
              onChange={(e) =>
                setNuevoServicio({ ...nuevoServicio, duracion: e.target.value })
              }
            />
          </div>

          <div className="label-form">
            <label htmlFor="nuevo-precio">Precio (€)</label>
            <input
              id="nuevo-precio"
              type="number"
              placeholder="Precio"
              value={nuevoServicio.precio}
              onChange={(e) =>
                setNuevoServicio({ ...nuevoServicio, precio: e.target.value })
              }
            />
          </div>

          <button onClick={crearServicio}>Crear</button>
        </div>
      </div>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </main>
  );
};

export default ServiciosAdmin;
